export default __webpack_public_path__ + "static/media/243.d4d04ca0.jpg";